// Strings for the storeMenu screens brought over from the app (pinto). One namespace
// per file so features can be edited independently; merged in parity/index.ts.
// Mirrors pinto's nav.more_stores_with / nav.upgrade_link / upgrade.* keys.
export const storeMenuEn = {
  storeMenu: {
    moreStoresWith: "More stores with {{plan}}",
    upgradeLink: "Upgrade ›",
    proLabel: "Pro",
    title: "{{name}} is in {{plan}}",
    subStore: "Add {{name}} and more chains to your local deals.",
    subBestDeals: "The biggest markdowns across your stores, every day.",
    rowChains: "Chains",
    rowStores: "Home stores",
    rowExtra: "Extra nearby",
    rowChanges: "Store swaps",
    rowBestDeals: "Best Deals",
    rowHawkFinds: "Hawk Finds",
    basicChains: "Walmart & HD",
    plusChains: "9 chains",
    basicStores: "1",
    plusStores: "Up to 3",
    proStores: "Up to 5",
    basicExtra: "+4",
    plusExtra: "+7",
    proExtra: "+10–15",
    proExtraWalmart: "+15",
    proExtraHomeDepot: "+10",
    basicChanges: "1 a day",
    plusChanges: "Unlimited",
    notIncluded: "—",
    included: "Included",
    cancelAnytime: "Cancel anytime",
    cta: "Upgrade to {{plan}}",
    notNow: "Not now",
  },
};

export const storeMenuEs: { storeMenu: Record<keyof typeof storeMenuEn.storeMenu, string> } = {
  storeMenu: {
    moreStoresWith: "Más tiendas con {{plan}}",
    upgradeLink: "Mejorar ›",
    proLabel: "Pro",
    title: "{{name}} está en {{plan}}",
    subStore: "Suma {{name}} y más tiendas a tus ofertas locales.",
    subBestDeals: "Las rebajas más fuertes de todas tus tiendas, cada día.",
    rowChains: "Tiendas",
    rowStores: "Principales",
    rowExtra: "Extra cercanas",
    rowChanges: "Cambios",
    rowBestDeals: "Mejores ofertas",
    rowHawkFinds: "Hawk Finds",
    basicChains: "Walmart y HD",
    plusChains: "9 tiendas",
    basicStores: "1",
    plusStores: "Hasta 3",
    proStores: "Hasta 5",
    basicExtra: "+4",
    plusExtra: "+7",
    proExtra: "+10–15",
    proExtraWalmart: "+15",
    proExtraHomeDepot: "+10",
    basicChanges: "1 al día",
    plusChanges: "Sin límite",
    notIncluded: "—",
    included: "Incluido",
    cancelAnytime: "Cancela cuando quieras",
    cta: "Mejorar a {{plan}}",
    notNow: "Ahora no",
  },
};
